<script>
const BASE_CLASS = 'form-control input-sm'

export default {
  name: 'MobileInput',
  props: {
    value: String,
    disabled: Boolean,
  },
  model: {
    event: 'change',
  },
  data: function () {
    return {
      cssClass: BASE_CLASS,
    }
  },
  methods: {
    pushValue: function ({ target: { value } }) {
      const isNotEmpty = value !== ''
      const isNumeric = /^[0-9]*$/g.test(value)
      const isMin = value.length >= 10
      const isMax = value.length <= 10
      const rules = [isNotEmpty, isNumeric, isMin, isMax]
      // Validate rules
      const isValid = rules.every((i) => i)
      // Set cosmetic
      this.cssClass = !isValid ? BASE_CLASS + ' bd-red' : BASE_CLASS
      // Push out value
      this.$emit('change', value)
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      let charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <input
    maxlength="10"
    :class="cssClass"
    :value="value"
    :disabled="disabled"
    @change="pushValue"
    @keydown="isNumber"
  />
</template>
